export default __webpack_public_path__ + "static/media/helloword.d4c0c68c.PNG";